export enum SkeletonMode {
  LOADING = 'loading',
  GENERATING = 'generating',
}
